// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ZliF","inner":"Form_inner__1JQfR","range":"Form_range__39hCR","name":"Form_name__2ns5l","actions":"Form_actions__3-hPU"};